<template>
  <div>
    <Alerts ref="alert"/>
    <Forms ref="frmSinister"
            :title="this.$lang.CarInspection.Register.TitleForm"
            :showHelp="false"
            :showClearButton="hasRole(this.roles.RW_REG_TABDETAILS) && !isCompleted"
            :showSaveButton="hasRole(this.roles.RW_REG_TABDETAILS) && !isCompleted"
            v-on:Clear="onClear"
            v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtCodeSinister"><small v-show="form.sinisterCode.required" class="text-danger">*</small>  {{$lang.CarInspection.Register.Board}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          class="txt-uppercase"
                          name="txtCodeSinister"
                          :placeholder="$lang.CarInspection.Register.PlaceholderBoard"
                          v-model="form.sinisterCode.value"
                          :size="form.sinisterCode.maxlength"
                          :required="form.sinisterCode.required"
                          :state="form.sinisterCode.state"
                          :disabled="isCompleted"
                          v-mask="'XXXXXXX'"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterVersion" title="Ordem de Serviço"><small v-show="form.sinisterVersion.required" class="text-danger">*</small> {{$lang.CarInspection.Register.ServiceOrder}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtSinisterVersion"
                          title="Ordem de Serviço"
                          :placeholder="'00000'"
                          v-model="form.sinisterVersion.value"
                          :maxlength="form.sinisterVersion.maxlength"
                          :required="form.sinisterVersion.required"
                          :state="form.sinisterVersion.state"
                          :disabled="isCompleted"
                          @blur.native="onCheckSinister"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxSinisterInsurer"><small v-show="form.insuranceID.required" class="text-danger">*</small> {{$lang.CarInspection.Register.Insurer}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.insuranceID.value"
                          :options="getAllInsurer"
                          :state="form.insuranceID.state"
                          class="mb-3"
                          name="cbxSinisterInsurer"
                          :disabled="isCompleted"
                          @change="onChangeInsurance">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxSinisterStage"><small v-show="form.stageID.required"  class="text-danger">*</small> {{$lang.CarInspection.Register.Stage}}: <a v-if="isCompleted && hasRole(this.roles.FUN_UNLOCKREG)" href="javascript:void(0)" v-b-tooltip.hover :title="'Clique para desbloquear o estágio'" @click="onUnlockStage"><i class="fa fa-unlock-alt" aria-hidden="true"></i></a></label>
          <div class="input-group">
            <b-form-select v-model="form.stageID.value"
                          :options="getAllStage"
                          :state="form.stageID.state"
                          class="mb-3"
                          name="cbxSinisterStage"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxSinisterTypeInspection"><small v-show="form.regulationTypeID.required" class="text-danger">*</small> {{$lang.CarInspection.Register.TypeRegulation}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.regulationTypeID.value"
                          :options="getAllRegulationType"
                          :state="form.regulationTypeID.state"
                          class="mb-3"
                          name="cbxSinisterTypeInspection"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtReceiptDate"><small v-show="form.receiptDate.required"  class="text-danger">*</small> {{$lang.CarInspection.Register.ReceiptDate}}:</label>
          <div class="input-group">
            <datepicker name="txtReceiptDate" v-model="form.receiptDate.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-3 d-none">
          <label for="cbxSinisterResponsible"><small v-show="form.responsibleID.required" class="text-danger">*</small> {{$lang.CarInspection.Register.Responsible}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.responsibleID.value"
                          :options="getAllAnalyst"
                          :state="form.responsibleID.state"
                          class="mb-3"
                          name="cbxSinisterResponsible"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxBudgetSystem"><small v-show="form.budgetSystemID.required" class="text-danger">*</small> {{$lang.CarInspection.Register.BudgetSystem}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.budgetSystemID.value"
                          :options="getAllBudgetSystem"
                          :state="form.budgetSystemID.state"
                          class="mb-3"
                          name="cbxBudgetSystem"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>

      <div class="form-group row" v-if="getMechanicalWorkshopID === null">
        <div class="col-md-12 intermediate-bar"><i class="fa fa-wrench"></i>&nbsp; {{$lang.CarInspection.Register.DataMachineWorkshop}}</div>
      </div>
      <SinisterMechanicalWorkshop ref="MechanicalWorkshop" @Edit="onEditMechanicalWorkshop" v-if="getMechanicalWorkshopID === null"/>

      <div class="form-group row"><div class="col-md-12 intermediate-bar"><i class="fa fa-car"></i>&nbsp; {{$lang.CarInspection.Register.DataCar}}</div></div>
      <div class="form-group row">
        <div class="col-md-4">
           <label for="cbxAutoType"><small v-show="form.autoTypeID.required" class="text-danger">*</small> {{$lang.AutoModel.Autotype}}:</label>
            <div class="input-group">
              <b-form-select v-model="form.autoTypeID.value"
                            :options="form.autoTypeID.options"
                            :state="form.autoTypeID.state"
                            class="mb-3"
                            name="cbxAutoType"
                            :disabled="isCompleted"
                            @change="onChangeAutoType">
                  <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                </template>
              </b-form-select>
            </div>
        </div>
        <div class="col-md-4">
          <label for="cbxBrand"><small v-show="form.brandID.required" class="text-danger">*</small> {{$lang.AutoModel.LabelBrand}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.brandID.value"
                              :options="form.brandID.options"
                              :state="form.brandID.state"
                              class="mb-3"
                              name="cbxBrand"
                              :disabled="isCompleted"
                              @change="onChangeBrand">
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <optgroup :label="$lang.Common.PlaceholderOptGroupDefault">
                  <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                  <option :value="null">{{$lang.Common.PlaceholderAddSelect}}</option>
                </optgroup>
                <optgroup :label="$lang.Common.PlaceholderOptGroupOptions"></optgroup>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxAutoModel"><small v-show="form.autoModelID.required" class="text-danger">*</small> {{$lang.CarInspection.Register.AutoModel}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.autoModelID.value"
                                  :options="form.autoModelID.options"
                                  :state="form.autoModelID.state"
                                  class="mb-3"
                                  name="cbxBrand"
                                  :disabled="isCompleted">
                    <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <optgroup :label="$lang.Common.PlaceholderOptGroupDefault">
                      <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                      <option :value="null">{{$lang.Common.PlaceholderAddSelect}}</option>
                    </optgroup>
                    <optgroup :label="$lang.Common.PlaceholderOptGroupOptions"></optgroup>
                  </template>
                </b-form-select>
              </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtYear"><small v-show="form.year.required"  class="text-danger">*</small> {{$lang.CarInspection.Register.Year}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtYear"
                          :placeholder="'2018-2018'"
                          v-model="form.year.value"
                          :size="form.year.maxlength"
                          :required="form.year.required"
                          :state="form.year.state"
                          v-mask="['####-####']"
                          :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtColor"><small v-show="form.color.required" class="text-danger">*</small> {{$lang.CarInspection.Register.Color}}:</label>
              <div class="input-group">
                 <b-form-input type="text"
                          name="txtColor"
                          :placeholder="'Branco'"
                          v-model="form.color.value"
                          :size="form.color.maxlength"
                          :required="form.color.required"
                          :state="form.color.state"
                          :disabled="isCompleted"/>
              </div>
        </div>
        <div class="col-md-4">
         <label for="txtChassis"><small v-show="form.chassis.required"  class="text-danger">*</small> {{$lang.CarInspection.Register.Chassis}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtChassis"
                          :placeholder="'XXXXXXXXXXXXXXXXX'"
                          v-mask="'XXXXXXXXXXXXXXXXX'"
                          v-model="form.chassis.value"
                          :size="form.chassis.maxlength"
                          :required="form.chassis.required"
                          :state="form.chassis.state"
                          :disabled="isCompleted"/>
          </div>
        </div>
      </div>
      <div class="form-group row"><div class="col-md-12 intermediate-bar"><i class="fa fa-bullhorn"></i>&nbsp; DADOS GERAIS</div></div>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtObservations"><small v-show="form.description.required" class="text-danger">*</small> {{$lang.Sinister.Details.GeneralObservations}}:</label>
          <b-form-textarea name="txtObservations"
                          v-model="form.description.value"
                          :placeholder="$lang.Sinister.Details.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"
                          :disabled="isCompleted"/>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>

    <b-modal ref="modal-unlock-regulation" size="lg" hide-footer title="DESBLOQUEIO DE ESTÁGIO DA REGULAÇÃO">
      <div class="d-block text-center">
        <h3 class="pt-2">
          <i class="fa fa-unlock-alt" aria-hidden="true"></i> Deseja realmente desbloquear a regulação?
        </h3>
        <div>
          <small>Você irá desbloquear uma regulação concluída e ela irá retornar ao estágio anterior (ORÇADO / REALIZADO)</small>
        </div>
      </div>
      <div class="text-center pt-3 pb-4">
        <b-button class="mt-2" variant="danger" @click="onUnlockStageModalClose">&nbsp;<i class="fa fa-times-circle" aria-hidden="true"></i> <strong>Não &nbsp;</strong></b-button>&nbsp;
        <b-button class="mt-2" variant="success" @click="onUnlockStageModalYes">&nbsp;<i class="fa fa-check-circle" aria-hidden="true"></i> <strong>Sim &nbsp;</strong></b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import register from './register.js'

export default register
</script>
<style lang="scss" scoped>
.tab-internal {
  border-left: solid 1px #cfd8dc;
  border-right: solid 1px #cfd8dc;
  border-bottom: solid 1px #cfd8dc;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.txt-uppercase {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/views/private/inspection/register/register.vue